

// Nuxt / Vendor
import Vue from "vue";

// Project
import SiteName from "~/components/SiteName.vue";
import SiteLogo from "~/components/SiteLogo.vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component imports -------------------------------------------------------

    components: {
        SiteName,
        SiteLogo
    }

    // -------------------------------------------------------------------------
});

